<fgb-page-header [pageTitle]="mobileTitle" [showBalance]="false"></fgb-page-header>
<div class="page-padding container">
  <fgbcl-lottos-wallet-details [lottoId]="id"></fgbcl-lottos-wallet-details>
</div>
